import { DataModel } from "common/models/utility-models/base-model";

export class LoginModel extends DataModel {
    email: string = '';
    password: string = '';
}